export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <img
                src="https://static.readdy.ai/image/f943031b43fc8da94030f1522c0523e1/6ec30ea469d650b6685d8f11bd18e554.png"
                alt="주식회사 프라임파트너스"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mt-5 max-w-md">
              주식회사 프라임파트너스는 시장 분석을 기반으로 회원 맞춤형 투자 정보를
              제공하는 유사투자자문 전문기업입니다. 데이터와 인사이트로 투자의 기준을 제시합니다.
            </p>

            <div className="mt-6 space-y-2 text-xs text-foreground-400">
              <div>대표이사: 도관인</div>
              <div>사업자등록번호: 249-81-03770</div>
              <div>
                주소: 경기도 의정부시 세석로20 폴리프라자1 10층
              </div>
              <div>
                대표번호:{" "}
                <a href="tel:+827070080070" className="hover:text-primary-500 cursor-pointer">
                  070-7008-0070
                </a>
              </div>
              <div>
                이메일:{" "}
                <a href="mailto:gagury1@naver.com" className="hover:text-primary-500 cursor-pointer">
                  gagury1@naver.com
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-xs tracking-widest text-primary-500 font-semibold mb-4">
              <a href="#services" className="hover:text-primary-400 cursor-pointer">서비스</a>
            </h4>
            <ul className="space-y-3 text-sm text-foreground-300">
              <li><a href="#services" className="hover:text-primary-500 cursor-pointer">시장 브리핑</a></li>
              <li><a href="#services" className="hover:text-primary-500 cursor-pointer">종목 분석</a></li>
              <li><a href="#services" className="hover:text-primary-500 cursor-pointer">VIP 컨설팅</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs tracking-widest text-primary-500 font-semibold mb-4">
              <a href="#contact" className="hover:text-primary-400 cursor-pointer">문의</a>
            </h4>
            <ul className="space-y-3 text-sm text-foreground-300">
              <li>
                <a href="tel:+827070080070" className="hover:text-primary-500 cursor-pointer">
                  070-7008-0070
                </a>
              </li>
              <li>
                <a href="mailto:gagury1@naver.com" className="hover:text-primary-500 cursor-pointer">
                  gagury1@naver.com
                </a>
              </li>
              <li>평일 오전 9:00 ~ 오후 06:00</li>
              <li>점심시간 오전 11:50 ~ 오후 13:00</li>
            </ul>
          </div>
        </div>

        <div className="gold-divider mt-14"></div>

        <div className="mt-8 space-y-5">
          <div className="text-xs text-foreground-500 leading-relaxed space-y-1.5">
            <p>※ 본 서비스는 유사투자자문 서비스입니다.</p>
            <p>※ 제공되는 정보는 투자 판단에 대한 참고자료이며 투자의 최종 책임은 투자자 본인에게 있습니다.</p>
            <p>※ 금융상품의 가치는 시장 상황에 따라 변동될 수 있으며 원금 손실이 발생할 수 있습니다.</p>
            <p>※ 과거의 수익률은 미래의 수익을 보장하지 않습니다.</p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-6 border-t border-background-300/40">
            <div className="text-xs text-foreground-500">
              © 2026 주식회사 프라임파트너스. All rights reserved.
            </div>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-500 cursor-pointer whitespace-nowrap">이용약관</a>
              <a href="#" className="hover:text-primary-500 cursor-pointer whitespace-nowrap">개인정보처리방침</a>
              <a href="#" className="hover:text-primary-500 cursor-pointer whitespace-nowrap">투자자 유의사항</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}